import { executeApiRequest } from './api-helpers'
import { IApiResponse, IApiCallOptions } from '@pushly/aqe/lib/interfaces'
import aqe from '@pushly/aqe'

export const fetchWhiteLabels = async (opts: IApiCallOptions = {}): Promise<IApiResponse<any[]>> => {
    return await executeApiRequest<any[]>('get', `${aqe.defaults.publicApiDomain}/v3/white-labels`, null, opts, {
        data: [],
    })
}

export const fetchWhiteLabel = async (id: number, opts: IApiCallOptions = {}): Promise<IApiResponse<any>> => {
    return await executeApiRequest<any>('get', `${aqe.defaults.publicApiDomain}/v3/white-labels/${id}`, null, opts, {
        data: undefined,
    })
}

export const createWhiteLabel = async (data: any, opts: IApiCallOptions = {}): Promise<IApiResponse<any>> => {
    return await executeApiRequest<any>('post', `${aqe.defaults.publicApiDomain}/v3/white-labels`, data, opts, {
        data: undefined,
    })
}

export const patchWhiteLabel = async (
    id: number,
    data: any,
    opts: IApiCallOptions = {},
): Promise<IApiResponse<any>> => {
    return await executeApiRequest<any>('patch', `${aqe.defaults.publicApiDomain}/v3/white-labels/${id}`, data, opts, {
        data: undefined,
    })
}

export const destroyWhiteLabel = async (id: number, opts: IApiCallOptions = {}): Promise<IApiResponse<any>> => {
    return await executeApiRequest<any>('delete', `${aqe.defaults.publicApiDomain}/v3/white-labels/${id}`, null, opts, {
        data: undefined,
    })
}
